import { useQuery } from '@tanstack/react-query';
import api from '@app/services/api';
import { apiEndpoints } from '@app/utils/constants';
import type { UseQueryOptions } from '@tanstack/react-query';
import type {
    ApiError,
    InteractionTypeListParams,
    InteractionTypeListResponse,
} from '@app/services/api.types';

type QueryOptions = Omit<
    UseQueryOptions<InteractionTypeListResponse, ApiError>,
    'queryKey' | 'queryFn'
>;

export const fetchInteractionTypeList = async (
    params: InteractionTypeListParams,
    signal?: AbortSignal
): Promise<InteractionTypeListResponse> => {
    const url = apiEndpoints.interactionTypes.getList(params);
    const response = await api.get(url, { signal });
    return response?.data?.data;
};

const useInteractionTypeList = (params: InteractionTypeListParams, options?: QueryOptions) => {
    return useQuery<InteractionTypeListResponse, ApiError>({
        queryKey: ['interaction', 'list', params],
        queryFn: ({ signal }) => fetchInteractionTypeList(params, signal),
        ...options,
    });
};

export default useInteractionTypeList;
